module.exports = __webpack_public_path__ + "media/svg/demographic-66da1600.svg";